<template>
    <div>
        <div
            v-if="
                product.relatedProductsUrl != null &&
                product.relatedProductsUrl != ''
            "
        >
            <product-gallery
                :products-per-row="productsPerRow"
                :fetch-url="product.relatedProductsUrl"
            >
                <template #top-part>
                    <div :class="$style['header']">
                        {{
                            labels.frontendProductpage.shop
                                .recommendedProductsHeader
                        }}
                    </div>
                </template>
            </product-gallery>
        </div>
    </div>
</template>

<style module lang="scss">
@import "../../../../responsive/style.scss";

.header {
    text-align: center;
    flex: 1;
    color: #000000;
    font-family: "Open Sans";
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 40px;

    @include media-breakpoint-up(lg) {
        font-size: 25px;
    }
}
</style>

<script setup lang="ts">
import { type PropType, computed } from "vue";
import productGallery from "../../frontend-productgallery/ProductGallery.vue";
import labels from "../../shared/labels";
import { type AuctionProduct } from "./types";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";

defineProps({
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
});

const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const productsPerRow = computed(() => {
    if (currentBreakpoint.value?.up("lg") == true) return 5;
    return 2;
});
</script>
